<template>
  <Layout>
    <slot />
  </Layout>
</template>

<script setup lang="ts">
import Layout from '~/components/Layout.vue'
</script>
